import { PAGES } from "../../features/navigation/types/pages.constant";

import { CAMPAIGN_TEMPLATE } from "../templates/campaign-brief/campaign-brief-template.enum";
import { EXECUTION_TEMPLATE } from "../templates/execution-brief/execution-brief-template.enum";
import { WORK_ORDER_TEMPLATE } from "../templates/work-order/work-order-template.enum";

import { BasicResourceType } from "./resources.enums";
import { TResourcePathsMap, TResourceTypesMap } from "./resources.types";

export const resourceTypesMap: TResourceTypesMap = {
  [BasicResourceType.CampaignBrief]: CAMPAIGN_TEMPLATE,
  [BasicResourceType.ExecutionBrief]: EXECUTION_TEMPLATE,
  [BasicResourceType.WorkOrder]: WORK_ORDER_TEMPLATE,
};

export const resourcePathsMap: TResourcePathsMap = {
  [BasicResourceType.CampaignBrief]: PAGES.CAMPAIGN_BRIEF.URL,
  [BasicResourceType.ExecutionBrief]: PAGES.EXECUTION_BRIEF.URL,
  [BasicResourceType.Flyer]: PAGES.FLYERS.URL,
  [BasicResourceType.FlyerPage]: PAGES.FLYER_PAGES.URL,
  [BasicResourceType.WorkOrder]: PAGES.WORK_ORDER.URL,
};
